import type { RootState } from "@/app/store/store";
import React from "react";
import { useSelector } from "react-redux";
import { Navigate, Outlet, useLocation } from "react-router-dom";
import type { PersistPartial } from "redux-persist/es/persistReducer";

const redirectPaths = {
	"/login": "/courses",
	"/": "/courses",
	"/register": "/courses",
} as {
	[key: string]: string;
};

export const RedirectedRoute = () => {
	const location = useLocation();
	const isAuthenticated = useSelector(
		(
			state: RootState &
				PersistPartial & { auth: { isAuthenticated: boolean } },
		) => state.auth.isAuthenticated,
	);

	const redirectPath = redirectPaths[location.pathname];

	if (isAuthenticated && redirectPath) {
		return <Navigate to={redirectPath} />;
	}

	return <Outlet />;
};
